import { Text, Flex } from "@jsq/ds/core";
import { Icon } from "@jsq/ds/icons";
import { Colors } from "@jsq/ds/styles";
import { SPACING } from "~/styles/variables";

interface Props {
  documentName?: string;
}

const DocumentDetailsRow = ({ documentName }: Props) => {
  return (
    <Flex alignItems="center">
      <div css={{ padding: SPACING.MEDIUM, backgroundColor: Colors.Neutral100 }}>
        <Icon color={Colors.Neutral600} type="file-alt" size="large" variant="solid" />
      </div>
      <Text data-testid="document-name" css={{ paddingLeft: SPACING.MEDIUM }}>
        {documentName}
      </Text>
    </Flex>
  );
};

export default DocumentDetailsRow;
